import React from "react"
import cn from "classnames"

import style from "./styles.module.scss"

interface Props {
    children: React.ReactNode
    className?: string
    dataTestId?: string
}

export function Title({ children, className, dataTestId = "default" }: Props) {
    return (
        <div className={cn(style.header, className)} data-testid={`hraccount-title-${dataTestId}`}>
            {children}
        </div>
    )
}
